// API Configuration
const LOCAL_URL = 'http://localhost:5001/api/v1';

export const API_URL = process.env.REACT_APP_API_URL || LOCAL_URL;

export const getBaseUrl = () => API_URL;

// App Store URLs
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/myfitness';
export const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.myfitness';

const config = {
  API_URL,
  getBaseUrl,
  APP_STORE_URL,
  PLAY_STORE_URL,
};

export default config;
